export default function randomIdGenerator() {
  let randomizer;

  if (window.crypto) {
    randomizer = new Uint32Array(1);
    crypto.getRandomValues(randomizer);
    randomizer = randomizer[0];
  } else {
    randomizer = Math.floor(Math.random() * 99999).toString();
  }

  return new Date().valueOf() + '-' +  randomizer  + '-' +  Math.floor(Math.random() * 99999).toString();
}